module.exports = __webpack_public_path__ + "static/img/join.1ccbe80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/join.jpg
// module id = yBPd
// module chunks = 1